import { render, staticRenderFns } from "./titleText.vue?vue&type=template&id=2a9b004f&"
import script from "./titleText.vue?vue&type=script&lang=js&"
export * from "./titleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports